import React from 'react';
import { Button } from '@/components/ui/button';

export interface ShareExperienceSectionProps {
  onWriteReviewClick: () => void;
  className?: string;
}

const ShareExperienceSection: React.FC<ShareExperienceSectionProps> = ({
  onWriteReviewClick,
  className,
}) => {
  return (
    <div className={`bg-gray-50 rounded-lg p-6 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900 mb-2">
            Share Your Experience
          </h3>
          <p className="text-gray-600 text-sm">
            Help other users by writing a review about your experience with this service.
          </p>
        </div>
        <Button 
          onClick={onWriteReviewClick}
          className="ml-6 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2"
        >
          Write a Review
        </Button>
      </div>
    </div>
  );
};

export { ShareExperienceSection }; 
